import {init, addMessages, getLocaleFromNavigator} from 'svelte-i18n';

/**
 * @param {Record<string, import('svelte-i18n').LocaleDictionary>} translations
 * @param {string} [locale='en']
 */
export function setupI18n(translations = {}, locale = 'en') {
  // Add translations synchronously
  Object.entries(translations).forEach(([lang, messages]) => {
    addMessages(lang, messages);
  });

  init({
    fallbackLocale: 'en',
    initialLocale: locale || getLocaleFromNavigator(),
  });
}
